//src/pages/REG/REG930F1.jsx
import React, {useContext, useEffect, useState} from 'react';
import style from "./REG920F1.module.scss";
import Button from "components/Button/Button";
import InputUnitText from "components/InputText/InputUnitText";
import {postData} from 'utils/TransactionUtil';
import styleCom from "./REGCOM.module.scss";
import DataGrid from "../../components/DataGrid/DataGrid";
import SelectBox from "../../components/SelectBox/SelectBox"; //상세화면
//엑셀
import * as XLSX from "xlsx"
import ExcelJS from "exceljs";
import {saveAs} from "file-saver";
import {AuthContext} from "../../contexts/AuthContext";


// 페이지 시작
const REG930F1 = ({navBar: NavBar}) => {

    const authContext = useContext(AuthContext);
    const userInfo = authContext.userInfo; // 사용자 정보 가져오기
    const [comHsptObj, setComHsptObj] = useState([]); //기관 리스트(공통)


    const [rows_subjectList, setRows_subjectList] = useState([]);
    const cols_subjectList = [
        //{ key: 'sqnc',           name: 'NO',      width: '5%', renderCell: ({ rowIdx }) => rowIdx+1},
        { key: 'hsptNm',   name: '기관명',  width: '30%'},
        { key: 'randId',   name: '아이디',  width: '20%' },
        { key: 'randIdNm', name: '성명',    width: '30%' },
        { key: 'randGrp',  name: '랜덤그룹', width: '20%'}
    ];

    const [rows_subjectDtlList, setRows_subjectDtlList] = useState([]);
    const cols_subjectDtlList = [
        //{ key: 'sqnc',           name: 'NO',      width: '5%', renderCell: ({ rowIdx }) => rowIdx+1},
        { key: 'hsptNm',   name: '기관명',  width: '20%'},
        { key: 'randIdNm', name: '성명',  width: '10%' },
        { key: 'randGrp',  name: '랜덤그룹',    width: '10%'},
        { key: 'randSno', name: '순번',    width: '10%'},
        { key: 'randIndex', name: '구분값',    width: '10%'},
        { key: 'randIndexNm', name: '구분',    width: '20%'},
        { key: 'mapId', name: '환자 등록번호',    width: '20%'}
    ];

    const [schRandId, setSchRandId]  = useState("");
    const [schHsptCd, setSchHsptCd]  = useState("");

    //form load
    useEffect(() => {
        getComDtlsData(); //공통코드 조회
    }, []);


/*  Event ====================================================================================================*/

    //조회 버튼 클릭
    const handleClick_search = () => {
        getRandomMainList();
    }
    //출력 버튼 클릭
    const handleClick_export = () => {
        exportToExcel(cols_subjectDtlList, rows_subjectDtlList, "export_list");
    }


    const insertSpace = (index) => {
        return new Array(index).fill("\u00A0").map((space, idx) => (
            <span key={idx}>{space}</span>
        ));
    };


    // 데이터 클릭
    const handleClick_DataGrid_row = (e) => {
        const param = {randId:e.row.randId, hsptCd:e.row.hsptCd, randGrp:e.row.randGrp};
        getRandomContent(param);

    }

/* Call Service====================================================================================================*/
    async function getComDtlsData() {
        //공통 기관정보
        const param1 = {comGrpCd:"HSPT_CD"}
        const resultData1 = await postData("/getComDtlsCd", param1);
        setComHsptObj(resultData1);
        setSchHsptCd(userInfo.hsptCd);
    }

    /* 데이터 조회  
    * 
    * */
    async function getRandomMainList(){
        //메인 데이터 조회
        const param = { randId:schRandId, hsptCd:schHsptCd};

        const res = await postData("/REW/getRandomMainList", param);
        setRows_subjectList(res);
        setRows_subjectDtlList([]);  //초기화
    }

    async function getRandomContent(param){
        //상세데이터 조회
        const res = await postData("/REW/getRandomContent", param);
        setRows_subjectDtlList(res);
    }


    /* 엑셀 ************************************************************************ */
    const exportToExcel = async (columns, rows, fileName) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Sheet1");

        // 헤더 추가
        worksheet.addRow(columns.map(col => col.name));

        // 데이터 추가
        rows.forEach(row => {
            const rowData = columns.map(col => row[col.key] ?? "");
            worksheet.addRow(rowData);
        });

        const totalRows = rows.length + 1; // 헤더 포함
        const totalCols = columns.length;

        // 컬럼 인덱스 찾기
        const hdColor1Index = columns.findIndex(col => col.key === "randIndex");
        const hdColor2Index = columns.findIndex(col => col.key === "randIndexNm");
        const hdColor3Index = columns.findIndex(col => col.key === "mapId");

        for (let r = 1; r <= totalRows; r++) {
            const row = worksheet.getRow(r);
            for (let c = 1; c <= totalCols; c++) {
                const cell = row.getCell(c);
                if (cell.value === undefined || cell.value === null) {
                    cell.value = "";
                }

                // 테두리 적용
                cell.border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    bottom: { style: "thin" },
                    right: { style: "thin" }
                };

                if (r === 1) {
                    cell.font = {bold: true}; // 헤더 글씨 굵게
                }

                // hd_color_1: 헤더만 노란색
                if (r === 1 && c - 1 === hdColor1Index) {
                    cell.fill = {
                        type: "pattern",
                        pattern: "solid",
                        fgColor: { argb: "FFFFFF00" } // 노란색
                    };
                }
                if (r === 1 && c - 1 === hdColor3Index) {
                    cell.fill = {
                        type: "pattern",
                        pattern: "solid",
                        fgColor: { argb: "FFFFFF00" } // 노란색
                    };
                }


                // hd_color_2: 헤더 + 내용 모두 노란색
                if (c - 1 === hdColor2Index) {
                    cell.fill = {
                        type: "pattern",
                        pattern: "solid",
                        fgColor: { argb: "FFFFFF00" } // 노란색
                    };
                }
            }
        }

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        saveAs(blob, `${fileName}.xlsx`);
    };
    /* ************************************************************************ */
    
    return (
        <main className={styleCom.main_wrap}>
            <NavBar>
                {/*공통 영역*/}
                <div className={styleCom.search_wrap}>
                    <Button variant="Primary" size="md" addStyle={{width: "80px", height: "40px"}}
                            onClick={handleClick_search}>
                        조회
                    </Button>
                    <Button variant="Primary" size="md" addStyle={{width: "80px", height: "40px"}}
                            onClick={handleClick_export}>
                        Excel
                    </Button>

                </div>
                <table className={style.search_table} style={{height: "72px", marginTop: "5px"}}>
                    <tbody>
                    <tr>

                        <td className={style.content_typ1} style={{width: "50px"}}> 기관</td>
                        <td className={style.content_typ1} style={{width: "250px"}}>
                            <SelectBox options={comHsptObj}
                                       value={schHsptCd}
                                       onChange={(val) => setSchHsptCd(val)}
                                       width={'90%'}/>
                        </td>
                        <td className={style.content_typ1} style={{width: "50px"}}> ID</td>
                        <td className={style.content_typ1}>
                            <InputUnitText type={"text"} value={schRandId} unit={""}
                                           onChange={(value) => setSchRandId(value)}/>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </NavBar>
            {/*검색영역*/}
            <br/>

            <div style={{display: "flex"}}>
                <div style={{width:"40%"}}>
                <DataGrid
                    cols={cols_subjectList}
                    rows={rows_subjectList}
                    rowHeight={37}
                    onCellClick={(e) => handleClick_DataGrid_row(e)}
                    //onCellDoubleClick={(e) => handleDoubleClick_DataGrid_row(e)}
                    sortable={true}
                    isNodataView={true}
                />
                </div>
                {insertSpace(4)}
                <div style={{width: "60%"}}>
                    <DataGrid
                        cols={cols_subjectDtlList}
                        rows={rows_subjectDtlList}
                        rowHeight={37}
                        sortable={true}
                        isNodataView={true}
                    />
                </div>


            </div>


        </main>


    )
        ;
};


export default REG930F1;
